
export default {
  // Hero Section
  'hero.slide1.title': 'گلخانه‌های هوشمند برای آینده‌ای سبز',
  'hero.slide1.subtitle': 'فناوری هلندی، کیفیت ایرانی',
  'hero.slide1.description': 'با بیش از ۱۵ سال تجربه، پیشرو در ساخت گلخانه‌های مدرن و تجهیزات کشاورزی پیشرفته',
  'hero.slide2.title': 'تکنولوژی پیشرفته کشاورزی',
  'hero.slide2.subtitle': 'سیستم‌های هوشمند آبیاری و کنترل اقلیم',
  'hero.slide2.description': 'ارائه کامل‌ترین راه‌حل‌های تکنولوژیک برای افزایش بهره‌وری و کیفیت محصولات کشاورزی',
  'hero.slide3.title': 'شریک موثق کشاورزان ایران',
  'hero.slide3.subtitle': 'بیش از ۵۰ پروژه موفق در سراسر کشور',
  'hero.slide3.description': 'از طراحی تا اجرا و پشتیبانی، همراه شما در مسیر توسعه کشاورزی مدرن و پایدار',
  
  // Buttons
  'buttons.view_products': 'مشاهده محصولات',
  'buttons.request_consultation': 'درخواست مشاوره',
  'buttons.view_projects': 'پروژه‌ها',
  
  // Stats Section
  'stats.projects': 'پروژه موفق',
  'stats.area': 'متر مربع ساخت',
  'stats.experience': 'سال تجربه',
  'stats.customers': 'مشتری راضی',
  
  // Services Section
  'services.title': 'خدمات ما',
  'services.description': 'ارائه کامل‌ترین خدمات در زمینه طراحی، ساخت و نگهداری گلخانه‌های مدرن',
  'services.design.title': 'طراحی و ساخت گلخانه',
  'services.design.description': 'طراحی و ساخت گلخانه‌های مدرن با فناوری روز دنیا و استانداردهای بین‌المللی',
  'services.smart.title': 'سیستم‌های هوشمند',
  'services.smart.description': 'نصب و راه‌اندازی سیستم‌های کنترل اقلیم، آبیاری و مانیتورینگ هوشمند',
  'services.consulting.title': 'مشاوره تخصصی',
  'services.consulting.description': 'ارائه مشاوره‌های تخصصی در زمینه کشاورزی مدرن و بهینه‌سازی تولید',
  'services.maintenance.title': 'نگهداری و پشتیبانی',
  'services.maintenance.description': 'خدمات نگهداری، تعمیر و پشتیبانی ۲۴ ساعته برای تمام تجهیزات',
  
  // About Section
  'about.title': 'درباره گلخانه سبز آریا',
  'about.description1': 'پیشرو در ساخت گلخانه‌های مدرن و ارائه راه‌حل‌های نوآورانه کشاورزی',
  'about.why_us.title': 'چرا Iran GH؟',
  'about.why_us.experience': 'بیش از ۱۵ سال تجربه موفق',
  'about.why_us.quality': 'کیفیت تضمین شده محصولات',
  'about.why_us.support': 'پشتیبانی ۲۴/۷ متخصصان',
  'about.why_us.projects': 'بیش از ۵۰ پروژه موفق',
  'about.why_us.description': 'با تکیه بر تجربه و دانش فنی، بهترین راه‌حل‌های گلخانه‌ای را برای شما فراهم می‌کنیم.',
  'about.expertise.title': 'تخصص ما',
  'about.expertise.smart_design': 'طراحی گلخانه‌های هوشمند',
  'about.expertise.climate_control': 'سیستم‌های کنترل اقلیم',
  'about.expertise.irrigation': 'تجهیزات آبیاری پیشرفته',
  'about.expertise.consulting': 'مشاوره تخصصی کشاورزی',
  'about.expertise.description': 'تیم متخصص ما با بهره‌گیری از جدیدترین فناوری‌ها، راه‌حل‌های نوآورانه ارائه می‌دهد.',
  'about.partnership.title': 'شراکت بین‌المللی',
  'about.partnership.dutch_tech': 'فناوری هلندی پیشرفته',
  'about.partnership.vander_hoeven': 'شراکت با Vander Hoeven',
  'about.partnership.european_standards': 'استانداردهای اروپایی',
  'about.partnership.global_quality': 'تضمین کیفیت جهانی',
  'about.partnership.description': 'با شراکت‌های بین‌المللی، بهترین تکنولوژی‌های روز دنیا را در اختیار شما قرار می‌دهیم.',
  'about.cta.title': 'آماده همکاری با شما هستیم',
  'about.cta.description': 'از مشاوره رایگان تا اجرای کامل پروژه، در تمام مراحل کنار شما خواهیم بود',
  'about.cta.learn_more': 'درباره ما بیشتر بدانید',
  'about.cta.contact': 'تماس با ما',
  
  // Partners Section
  'partners.title': 'شرکای ما',
  'partners.description': 'همکاری با معتبرترین شرکت‌های داخلی و خارجی در زمینه فناوری گلخانه‌ای',
  'partners.international': 'شراکت‌های بین‌المللی',
  'partners.vander.name': 'Vander Hoeven',
  'partners.vander.country': 'شریک رسمی هلندی',
  'partners.vander.years': '۱۰+ سال همکاری',
  'partners.vander.tech': 'فناوری پیشرفته هلندی',
  'partners.vander.description': 'شریک رسمی هلندی با بیش از ۱۰ سال همکاری موفق',
  'partners.chehelsotoon.name': 'Chehelsotoon',
  'partners.chehelsotoon.country': 'شریک تجاری داخلی',
  'partners.chehelsotoon.years': '۸+ سال همکاری',
  'partners.chehelsotoon.quality': 'تولید محلی با کیفیت',
  'partners.chehelsotoon.description': 'شریک تجاری داخلی با تولید محلی باکیفیت',
  'partners.benefits.title': 'مزایای شراکت‌های ما',
  'partners.benefits.description': 'چرا شراکت با ما انتخاب درستی است؟',
  'partners.benefits.global_access': 'دسترسی جهانی',
  'partners.benefits.global_desc': 'ارتباط با بازارهای بین‌المللی',
  'partners.benefits.advanced_tech': 'فناوری پیشرفته',
  'partners.benefits.tech_desc': 'آخرین تکنولوژی‌های روز دنیا',
  'partners.benefits.quality_guarantee': 'تضمین کیفیت',
  'partners.benefits.quality_desc': 'استانداردهای بین‌المللی کیفیت',
  'partners.benefits.support': 'پشتیبانی ۲۴/۷',
  'partners.benefits.support_desc': 'خدمات پس از فروش تخصصی',
  'partners.cta': 'شریک ما باشید',
  
  // Testimonials Section
  'testimonials.title': 'نظرات مشتریان',
  'testimonials.description': 'آنچه مشتریان ما درباره کیفیت خدمات و محصولات ما می‌گویند',
  'testimonials.customer1.name': 'احمد محمدی',
  'testimonials.customer1.position': 'مدیر مجموعه کشاورزی اصفهان',
  'testimonials.customer1.text': 'کیفیت ساخت و تجهیزات Iran GH فوق‌العاده است. گلخانه ما با بهترین تکنولوژی ساخته شده.',
  'testimonials.customer2.name': 'فاطمه کریمی',
  'testimonials.customer2.position': 'کارشناس کشاورزی مشهد',
  'testimonials.customer2.text': 'همکاری با Iran GH تجربه‌ای عالی بود. از مرحله طراحی تا اجرا همه چیز حرفه‌ای انجام شد.',
  'testimonials.customer3.name': 'رضا احمدی',
  'testimonials.customer3.position': 'مالک گلخانه اردبیل',
  'testimonials.customer3.text': 'تکنولوژی هلندی و خدمات ایرانی، ترکیبی عالی که باعث موفقیت کسب‌وکار ما شده.',
  
  // CTA Section
  'cta.title': 'آماده شروع پروژه بعدی خود هستید؟',
  'cta.description': 'با تیم متخصص ما تماس بگیرید و مشاوره رایگان دریافت کنید',
  'cta.phone': '۰۲۱۸۸۴۴۱۳۸۶',
  
  // Navigation
  'nav.read_more': 'بیشتر بخوانید',
  'nav.view_services': 'مشاهده خدمات',
  'nav.view_partners': 'مشاهده شرکا',
  'nav.cooperation_level': 'میزان همکاری',
  
  // Story Section (added)
  story: {
    badge: 'تاریخچه شرکت گلخانه سبز آریا',
    title: 'داستان موفقیت گلخانه سبز آریا',
    subtitle: 'شرکت گلخانه سبز آریا با بیش از 15 سال تجربه در زمینه طراحی، ساخت و تجهیز گلخانه‌های مدرن، پیشرو در صنعت گلخانه‌سازی ایران و منطقه خاورمیانه محسوب می‌شود.',
    
    founding: {
      title: 'تأسیس شرکت گلخانه سبز آریا',
      description: 'گلخانه سبز آریا در سال 2009 با هدف ارائه راه‌حل‌های نوآورانه در صنعت گلخانه‌سازی تأسیس شد. شرکت ما از یک واحد کوچک مهندسی به بزرگترین ارائه‌دهنده تجهیزات گلخانه‌ای در کشور تبدیل شده است.'
    },
    
    growth: {
      title: 'رشد و توسعه گلخانه سبز آریا',
      description: 'طی سال‌های فعالیت، گلخانه سبز آریا بیش از 200 پروژه موفق را در سراسر کشور و منطقه اجرا کرده است. از گلخانه‌های خانوادگی کوچک تا مجتمع‌های تجاری بزرگ، همه در حیطه تخصص ما قرار دارند.'
    },
    
    achievements: {
      title: 'دستاوردهای گلخانه سبز آریا',
      description: 'امروزه گلخانه سبز آریا به عنوان پیشرو در فناوری‌های هوشمند گلخانه‌ای شناخته می‌شود و به کشاورزان کمک می‌کند تا با استفاده بهینه از منابع، بازدهی بالاتری کسب کنند.'
    },
    
    image_alt: 'تاریخچه و دستاوردهای شرکت گلخانه سبز آریا',
    
    highlight: {
      title: 'گلخانه سبز آریا - پیشرو در نوآوری',
      description: 'با بیش از 150,000 متر مربع گلخانه احداث شده و 100+ مشتری راضی'
    },
    
    timeline: {
      title: 'مسیر پیشرفت گلخانه سبز آریا',
      2009: {
        title: 'آغاز فعالیت',
        description: 'تأسیس شرکت گلخانه سبز آریا با تیمی متخصص و متعهد'
      },
      2015: {
        title: 'گسترش خدمات',
        description: 'ارائه خدمات طراحی و ساخت گلخانه‌های هوشمند'
      },
      2020: {
        title: 'رهبری بازار',
        description: 'تبدیل شدن به پیشرو در صنعت گلخانه‌سازی ایران'
      },
      2024: {
        title: 'نوآوری مداوم',
        description: 'معرفی فناوری‌های پیشرفته IoT و هوش مصنوعی'
      }
    },
    
    milestones: {
      projects: {
        title: 'پروژه‌های موفق گلخانه سبز آریا',
        subtitle: 'بیش از 200 پروژه تکمیل شده',
        description: 'گلخانه سبز آریا با اجرای موفقیت‌آمیز پروژه‌های متنوع، از گلخانه‌های کوچک خانوادگی تا مجتمع‌های تجاری بزرگ، تجربه غنی و تخصص بالایی کسب کرده است.',
        item1: 'گلخانه‌های هیدروپونیک پیشرفته',
        item2: 'سیستم‌های کنترل اقلیم هوشمند',
        item3: 'تجهیزات آبیاری اتوماتیک'
      },
      expansion: {
        title: 'توسعه منطقه‌ای گلخانه سبز آریا',
        subtitle: 'حضور در خاورمیانه',
        description: 'گلخانه سبز آریا فعالیت خود را به کشورهای همسایه گسترش داده و به عنوان مرجع تخصصی در منطقه خاورمیانه شناخته می‌شود.',
        item1: 'صادرات تجهیزات به کشورهای همسایه',
        item2: 'مشاوره فنی و طراحی بین‌المللی',
        item3: 'شراکت با شرکت‌های معتبر منطقه'
      }
    },
    
    innovation: {
      title: 'نوآوری در گلخانه سبز آریا',
      subtitle: 'گلخانه سبز آریا همواره در خط مقدم فناوری‌های نوین قرار دارد و با تحقیق و توسعه مداوم، راه‌حل‌های پیشرفته‌ای ارائه می‌دهد.',
      research: {
        title: 'تحقیق و توسعه',
        description: 'سرمایه‌گذاری مداوم در تحقیقات علمی و توسعه فناوری‌های نوین گلخانه‌ای'
      },
      technology: {
        title: 'فناوری هوشمند',
        description: 'پیاده‌سازی سیستم‌های IoT، هوش مصنوعی و اتوماسیون پیشرفته'
      },
      sustainability: {
        title: 'پایداری محیطی',
        description: 'تمرکز بر راه‌حل‌های سازگار با محیط زیست و مصرف بهینه منابع'
      }
    }
  }
};
